import React from "react";
import "@/styles/boost.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Starfield from "@/components/Starfield";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import AISystems from "@/components/AISystems";
import Services from "@/components/Services";
import SeoTeaser from "@/components/SeoTeaser";
import PaidAds from "@/components/PaidAds";
import ClientSuccess from "@/components/ClientSuccess";
import Process from "@/components/Process";
import ToolsMarquee from "@/components/ToolsMarquee";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import RocketProgress from "@/components/RocketProgress";
import { Toaster } from "@/components/ui/toaster";
import PricingPage from "@/pages/PricingPage";
import EnquiryDashboard from "@/pages/EnquiryDashboard";
import CaseStudyImprint from "@/pages/CaseStudyImprint";
import CaseStudyTemple from "@/pages/CaseStudyTemple";
import CaseStudyDiamondbrite from "@/pages/CaseStudyDiamondbrite";
import CaseStudyLondonDrumsticks from "@/pages/CaseStudyLondonDrumsticks";
import WorkIndex from "@/pages/WorkIndex";
import QuoteBuilder from "@/pages/QuoteBuilder";
import AcceptQuote from "@/pages/AcceptQuote";
import LocationPage from "@/pages/LocationPage";
import JournalIndex from "@/pages/JournalIndex";
import JournalPost from "@/pages/JournalPost";
import JournalStrip from "@/components/JournalStrip";
import { SAFFRON_WALDEN, CAMBRIDGE, BISHOPS_STORTFORD, HAVERHILL, GREAT_DUNMOW } from "@/data/locationsData";

// Scrolls to a #hash section on load (e.g. arriving at "/#success" from another route)
function useHashScroll() {
  React.useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;
    const id = hash.slice(1);
    const scroll = () => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    const t = setTimeout(scroll, 300);
    return () => clearTimeout(t);
  }, []);
}

const Home = () => {
  useHashScroll();
  return (
  <div className="boost-app">
    <Starfield />
    <Navbar />
    <RocketProgress />
    <main>
      <Hero />
      <AISystems />
      <Services />
      <SeoTeaser />
      <PaidAds />
      <ClientSuccess />
      <Process />
      <ToolsMarquee />
      <JournalStrip />
      <FAQ />
      <Contact />
    </main>
    <Footer />
    <Toaster />
  </div>
  );
};

function AnimatedRoutes() {
  const location = useLocation();

  // Reset scroll to top on route change (but let hash links like /#success scroll themselves)
  React.useEffect(() => {
    if (!location.hash) window.scrollTo(0, 0);
  }, [location.pathname, location.hash]);

  return (
    <div key={location.pathname} className="page-fade">
      <Routes location={location}>
        <Route path="/" element={<Home />} />
        <Route path="/marketing-saffron-walden" element={<LocationPage data={SAFFRON_WALDEN} />} />
        <Route path="/marketing-cambridge" element={<LocationPage data={CAMBRIDGE} />} />
        <Route path="/marketing-bishops-stortford" element={<LocationPage data={BISHOPS_STORTFORD} />} />
        <Route path="/marketing-haverhill" element={<LocationPage data={HAVERHILL} />} />
        <Route path="/marketing-great-dunmow" element={<LocationPage data={GREAT_DUNMOW} />} />
        <Route path="/website-design-pricing" element={<PricingPage />} />
        <Route path="/work" element={<WorkIndex />} />
        <Route path="/quote" element={<QuoteBuilder />} />
        <Route path="/quote/accept/:id" element={<AcceptQuote />} />
        <Route path="/case-studies/imprint-mis" element={<CaseStudyImprint />} />
        <Route path="/case-studies/temple-of-sound" element={<CaseStudyTemple />} />
        <Route path="/case-studies/diamondbrite" element={<CaseStudyDiamondbrite />} />
        <Route path="/case-studies/london-drumstick-co" element={<CaseStudyLondonDrumsticks />} />
        <Route path="/journal" element={<JournalIndex />} />
        <Route path="/journal/tag/:tagSlug" element={<JournalIndex />} />
        <Route path="/journal/:slug" element={<JournalPost />} />
        <Route path="/admin/enquiries" element={<EnquiryDashboard />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AnimatedRoutes />
    </BrowserRouter>
  );
}

export default App;
